/**
 * Client KYB 相关 API
 * 基于 API 文档：https://xxx.ngrok-free.app/v2/api-docs
 * Tag: 客户端KYB (Client Segment Controller)
 */
import { request } from '@umijs/max';
import type { CommonResultSegmentVo, SegmentDto } from './clientKybTypes';

/** API 基础路径 */
const CLIENT_KYB_BASE = '/client/compliance/kyb';

/**
 * 新增 KYB
 * POST /client/compliance/kyb/add
 */
export async function postClientKybAdd(dto: SegmentDto, options?: { fillStatus?: string }) {
  const search = options?.fillStatus ? `?fillStatus=${encodeURIComponent(options.fillStatus)}` : '';
  return request<CommonResultSegmentVo>(`${CLIENT_KYB_BASE}/add${search}`, {
    method: 'POST',
    data: dto,
  });
}

/**
 * 获取 KYB 详情
 * GET /client/compliance/kyb/info/{id}
 */
export async function getClientKybInfo(params: { id: string }) {
  return request<CommonResultSegmentVo>(
    `${CLIENT_KYB_BASE}/info/${params.id}`,
    { method: 'GET' },
  );
}

/**
 * 修改 KYB
 * POST /client/compliance/kyb/update
 */
export async function postClientKybUpdate(dto: SegmentDto, options?: { fillStatus?: string }) {
  const search = options?.fillStatus ? `?fillStatus=${encodeURIComponent(options.fillStatus)}` : '';
  return request<CommonResultSegmentVo>(`${CLIENT_KYB_BASE}/update${search}`, {
    method: 'POST',
    data: dto,
  });
}
